import React, { FC } from "react";
import styled from "styled-components";
import { color } from "@styles";
import { Toggle } from "components/atoms/Toggle";
import { useAccordionContext } from "components/molecules/Accordion";

interface Props {
  id: string;
  title: string;
  checked: boolean;
  onCheck: (checked: boolean) => void;
}

export const CustomAccordionTitle: FC<Props> = ({ id, title, checked, onCheck }) => {
  const { onAccordionClick } = useAccordionContext();

  return (
    <StyledAccordionTitle>
      <StyledAccordionButton onClick={() => onAccordionClick(id)}>{title}</StyledAccordionButton>
      <Toggle label={title} checked={checked} onCheck={onCheck} />
    </StyledAccordionTitle>
  );
};

const StyledAccordionTitle = styled.div`
  background: ${color.S3100};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex: 1;
`;

const StyledAccordionButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  cursor: pointer;
  text-align: left;
  @media (max-width: 300px) {
    font-size: 0.875rem;
  }
`;
